<template>
    <div class="nscp-contract-info">
        <div class="title-container">
            <span class="sub-title">合同信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">合同编码</el-col>
                <el-col :span="5">{{ formData.contractCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">合同名称</el-col>
                <el-col :span="5">{{ formData.contractName }}</el-col>
                <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                <el-col :span="5">{{ formData.supplierName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">生效日期</el-col>
                <el-col :span="5">{{ formData.effectiveDate }}</el-col>
                <el-col class="has-bg right-text" :span="3">服务平台</el-col>
                <el-col :span="5">{{ formData.contractSiteName }}</el-col>
                <el-col class="has-bg right-text" :span="3">分公司</el-col>
                <el-col :span="5">{{ formData.contractCompanyName }}</el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
    props: {
        auditId: {
            type: String,
            default: ''
        },
        info: {
            type: Object,
            default: ({})
        },
    },
    data() {
        return {
            contentVisible: true,
            dictData: {},
            formData: {
                contractCode: '-',
                contractName: '-',
                supplierName: '-',
                effectiveDate: '-',
                contractSiteName: '-',
                contractCompanyName: '-',
            },
        }
    },
    mounted() {
        this.setFormData(this.info)
    },
    methods: {
        setFormData(data) {
            if (!data) return
            this.formData.contractCode = data.contractCode || '-'
            this.formData.contractName = data.contractName || '-'
            this.formData.supplierName = data.supplierName || '-'
            this.formData.effectiveDate = data.effectiveDate ? dayjs(data.effectiveDate).format('YYYY-MM-DD') : '-'
            this.formData.contractSiteName = data.contractSiteName || '-'
            this.formData.contractCompanyName = data.contractCompanyName || '-'
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
    },
}
</script>

<style lang="less">
.nscp-contract-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        float: none;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-top: 15px;
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }
}
</style> 